import { getHsaColumns } from "../dashboard/hsa/columns";
import { formatP2O5Method, formatPct } from "../formatters";
import { IAnalysisValueColumn } from "../types";

export interface IColumnDescription {
    id: number;
    name: string;
    visible: boolean;
    mandatory?: boolean;
}

export class TableColumns {

    private _standardAnalysisColumns: IAnalysisValueColumn[] = [
        { name: "P2O5", units: "ppm", header: "P<sub>2</sub>O<sub>5</sub>", index: true, visible: true, gauge: true, morgan: true },
        { name: "P2O5Method", header: "P<sub>2</sub>O<sub>5</sub> Method", formatter: value => formatP2O5Method(value) },
        { name: "K2O", units: "ppm", header: "K<sub>2</sub>O", index: true, visible: true, gauge: true, morgan: true },
        { name: "MgO", units: "ppm", index: true, visible: true, gauge: true, morgan: true },
        { name: "WaterpH", units: "", header: "pH", key: "pH", visible: true, gauge: true },

        { name: "SoilCEC", units: "meq/100g", header: "Soil CEC", key: "SoilCEC" },
        { name: "OrganicMatter", units: "%", header: "Organic Matter", key: "OrganicMatter", formatter: value => formatPct(value, 1) },
        { name: "Sand", units: "%", header: "Sand", key: "Sand" },
        { name: "Silt", units: "%", header: "Silt", key: "Silt" },
        { name: "Clay", units: "%", header: "Clay", key: "Clay" },

        { name: "Boron", units: "ppm", header: "Boron", key: "Boron" },
        { name: "CaO", units: "ppm", header: "Calcium", key: "CaO" },
        { name: "Copper", units: "ppm", header: "Copper", key: "Copper" },
        { name: "Iron", units: "ppm", header: "Iron", key: "Iron" },
        { name: "Molybdenum", units: "ppm", header: "Molybdenum", key: "Molybdenum" },
        { name: "Sodium", units: "ppm", header: "Sodium", key: "Sodium" },
        { name: "SO3", units: "ppm", header: "Sulphur", key: "SO3" },
        { name: "Zinc", units: "ppm", header: "Zinc", key: "Zinc" },
        { name: "Manganese", units: "ppm", header: "Manganese", key: "Manganese" },

        { name: "TotalP2O5", units: "kg/ha", header: "Total P<sub>2</sub>O<sub>5</sub>" },
        { name: "TotalK2O", units: "kg/ha", header: "Total K<sub>2</sub>O" },
        { name: "TotalMgO", units: "kg/ha", header: "Total MgO" },
        { name: "TotalCaO", units: "kg/ha", header: "Total CaO" },

        { name: "SoilHealthIndex", units: "", header: "Soil health index" },
        { name: "CO2BurstIndex", units: "", header: "CO<sup>2</sup> burst index" },
        { name: "CO2Burst", units: "mg/kg", header: "CO<sup>2</sup> burst" }
    ];

    public field: IColumnDescription = {
        id: 1,
        name: "Field",
        visible: true,
        mandatory: true
    };

    public number: IColumnDescription = {
        id: 2,
        name: "Analysis Number",
        visible: true,
        mandatory: true
    };

    public lab: IColumnDescription = {
        id: 3,
        name: "Laboratory",
        visible: false
    };

    public plotref = {
        id: 4,
        name: "Plot Reference",
        visible: true
    };

    public date = {
        id: 5,
        name: "Sampling Date",
        visible: true
    };

    public alloc = {
        id: 6,
        name: "Allocations",
        visible: true
    };

    public columns: IColumnDescription[];
    public standardAnalysisColumns: IAnalysisValueColumn[];
    public hsaColumns: IAnalysisValueColumn[];

    constructor() {

        this.columns = [
            this.field,
            this.number,
            this.lab,
            this.plotref,
            this.date,
            this.alloc
        ];

        this.standardAnalysisColumns = this._standardAnalysisColumns;

        this.hsaColumns = getHsaColumns()
    }

}
